export default __webpack_public_path__ + "static/media/crab.2fcf3244.png";